var _path, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 362.023 362.023"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 60.338h362.023v241.346H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#338af3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 60.338h362.023v30.168H0zm0 60.341h362.023v30.168H0zm0 60.335h362.023v30.168H0zm0 60.336h362.023v30.168H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 60.338h133.788v120.676H0z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 107.27h133.788v26.814H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.487 60.338h26.814v120.676H53.487z"
}))));

export default SvgGr;